export const GET_REGISTER_BROKER_NOTIFICATIONS  = 'GET_REGISTER_BROKER_NOTIFICATIONS';
export const GET_REGISTER_BROKER_NOTIFICATIONS_COUNT  = 'GET_REGISTER_BROKER_NOTIFICATIONS_COUNT';
export const REGISTER_BROKER_NOTIFICATIONS_REQUEST  = 'REGISTER_BROKER_NOTIFICATIONS_REQUEST';
export const REGISTER_BROKER_NOTIFICATIONS_REQUEST_FAILURE  = 'REGISTER_BROKER_NOTIFICATIONS_REQUEST_FAILURE';